export default __webpack_public_path__ + "static/recog-1-d55a27dcefb7ff6d403afdba8ca07cfe.webp";